import { Plus, Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function CategoriesTab({ categories, onCreateNew, onDelete }) {
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="text-2xl font-heading font-bold uppercase text-primary">Gerenciar Categorias</h2>
        <Button
          data-testid="create-category-button"
          onClick={onCreateNew}
          className="bg-primary text-primary-foreground hover:bg-primary/90 uppercase tracking-widest font-bold px-6 py-3 rounded-sm"
        >
          <Plus className="w-5 h-5 mr-2" />
          Nova Categoria
        </Button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {categories.map((category) => (
          <div key={category.id} data-testid={`category-${category.id}`} className="bg-card border border-border rounded-lg p-6">
            <h3 className="text-xl font-heading font-bold uppercase text-primary mb-2">{category.name}</h3>
            <p className="text-sm text-foreground/70 mb-4">{category.description || 'Sem descrição'}</p>
            {(category.age_min || category.age_max) && (
              <p className="text-xs text-foreground/50 mb-4">
                Idade: {category.age_min || '?'} - {category.age_max || '∞'} anos
              </p>
            )}
            <Button
              data-testid={`delete-category-${category.id}`}
              size="sm"
              variant="destructive"
              onClick={() => onDelete(category.id)}
              className="w-full rounded-sm"
            >
              <Trash2 className="w-4 h-4 mr-2" />
              Excluir
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
}
